import React, { useCallback, useEffect } from 'react';
import styles from './crud.module.scss';
import { KoForm, KoFormBuilder } from 'packages';
import WorkFlowStatus from 'shared/components/workflowstatus';

const PrStatusCrud =({ form, handleFinish, initialValues }) => {

  useEffect(() => {
    if (!initialValues || Object.keys(initialValues).length === 0) {
      form.resetFields();
    } else {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);

  const handleSubmit = useCallback(values => {
    handleFinish(values);
  });



  const Status = ({ value, onChange }) => (
    <WorkFlowStatus value={value} onChange={v => onChange(v)}/>
  );

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
    
      {
        key: 'status', label: 'Status', colSpan: 3,
        widget: Status, rules: [
          {
            required: true,
            message: `Please select status.`
          }
        ]
      }
    ]

  };

  return (
    <div className={styles.wrapper}>
      <KoForm form={form} layout="vertical"
        onFinish={handleSubmit} onSubmit={handleSubmit}
      >
        <KoFormBuilder form={form} meta={meta} />
      </KoForm>
    </div>
  );
};

export default PrStatusCrud;
